<template>
    <Sections>
        <AppSubheader title="Membership" :parent="{title: 'Home', route: '/'}" :dark="true"></AppSubheader>
        <SectionJumbo
            :image="$config.public.uploads + 'images-general/aaa-library-background-v2.jpg'"
            imageAlt="A show reel of Andy Guitar videos"
            imageOpacity="opacity-30"
            imagePosition="object-[0_20%]"
            :heading="'Thanks '+ currentUser.first_name + '!'"
            headingColor="text-white"
            content="<p>Your membership is active, this gives you unlimited access to all content and features. It also supports me to keep making great videos for you.</p>"
            contentColor="text-white"
            :textCentered="false"
        ></SectionJumbo>
        <SectionImage
            heading="All the courses!"
            headingColor="text-4xl font-semibold tracking-tight sm:text-6xl"
            content="<p>You have access to every course and lesson on the site, <strong>Nowhere is off limits</strong>.</p>"
            :image="$config.public.uploads + 'images-general/course-image-grid-3.png'"
            imageAlt="A selection of some of the courses you can find on the Andy Guitar website"
            buttonText="Browse Courses"
            buttonRoute="/courses"
            buttonColor="bg-amber-700 text-white hover:bg-amber-600 focus-visible:outline-amber-600"
        ></SectionImage>
        <SectionImage
            color="bg-zinc-50"
            heading="Join the Discord Community"
            headingColor="text-4xl font-semibold tracking-tight sm:text-6xl"
            content="<p>Don't forget, you can now join the Andy Guitar Online Community on Discord. Come and share your progress, get updates on what’s happening and connect with other members.</p>"
            :image="$config.public.uploads + 'images-general/guitar-breaks-may-2022-best-1.jpeg'"
            imageAlt="A group of andy guitar community members at in person meet up"
            :flip="true"
            buttonText="Join Discord"
            :buttonHref="currentUser && currentUser.aaa_community_discord_link"
            buttonColor="bg-amber-700 text-white hover:bg-amber-600 focus-visible:outline-amber-600"
        ></SectionImage>
        <SectionCards
            heading="Other Benefits"
            color="bg-zinc-100"
            :cards="[
                {
                    image: $config.public.uploads + 'images-tag/technique-course-image-2023a1.jpg',
                    imageAlt: 'Andy teaching some guitar techniques',
                    heading: 'Weekly Videos',
                    excerpt: '<p>Get full access to every lesson and every course. 500+ video lessons only available to Access All Areas Members</p>',
                },
                {
                    image: $config.public.uploads + 'images-general/new-tab-thumb.png',
                    imageAlt: 'Helpful interactive TAB',
                    heading: 'Interactive TAB',
                    excerpt: '<p>Play along with high quality interactive TABs</p>',
                },
                {
                    image: $config.public.uploads + 'images-live-stream/live-thumb-4-1.jpg',
                    heading: 'Live Streams',
                    imageAlt: 'Andy giving a live stream lesson to Andy Guitar members',
                    excerpt: '<p>Join the community. Engage with Andy in live streams and interact with others in lesson comments</p>',
                },
            ]"
        ></SectionCards>
        <SectionText
            v-if="subscription && subscription.id_subscription"
            heading="Need to make a change?"
            content="Manage the details of your subscription here."
            buttonText="Manage Membership"
            buttonColor="border border-zinc-200 bg-white text-black hover:border-zinc-300 focus-visible:outline-zinc-600"
            :buttonRoute="'/me/subscriptions/' + subscription.id_subscription"
        ></SectionText>
    </Sections>
</template>

<script>
import { mapState } from 'pinia';

export default {
    name: 'ContainerMembershipStatus',
    computed: {
        ...mapState(useStoreMembership, {
            subscription: 'subscription',
        }),
        ...mapState(useStoreAuth, {
            currentUser: 'currentUser'
        }),
    },
};
</script>
